export default __webpack_public_path__ + "static/media/la_photo_de_lanne.70a84d65.jpeg";